<brightside-web-display-campaign
  [campaign]="campaign"
  [analyticsAttributes]="{ event_name: 'survey_emoney_info' }"
  (campaignEvent)="handleCampaignEvent($event)"
  [showBackArrow]="true"
></brightside-web-display-campaign>
